import { Pipe, PipeTransform } from '@angular/core';
import { Channel } from 'src/app/shared/api-services/otp/models/otp-configuration.model';

const CHANNEL_MAP: Record<number, string> = {
  [Channel.SMS]: 'SMS',
  [Channel.EMAIL]: 'Email',
  [Channel.API]: 'API'
};

@Pipe({ name: 'otpChannelLabels' })
export class OtpChannelLabelsPipe implements PipeTransform {
  transform(channels: number[]): string {
    return (channels || []).map(c => CHANNEL_MAP[c] || String(c)).join(', ') || '-';
  }
}
